import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import RequireAdmin from "@/components/RequireAdmin";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import VisitorForm from "@/pages/VisitorForm";
import VisitorList from "@/pages/VisitorList";
import SettingsPage from "@/pages/Settings";
import PrintAbsensi from "@/pages/PrintAbsensi";
import PrintSuratPernyataan from "@/pages/PrintSuratPernyataan";
import PrintBulkAbsensi from "@/pages/PrintBulkAbsensi";
import BukuTamu from "@/pages/BukuTamu";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/buku-tamu" replace />} />
            <Route path="/buku-tamu" element={<BukuTamu />} />
            <Route path="/registrasi" element={<VisitorForm publicMode />} />

            {/* Admin layout (same Layout, protected) */}
            <Route path="/admin" element={<RequireAdmin><Dashboard /></RequireAdmin>} />
            <Route path="/admin/tamu" element={<RequireAdmin><VisitorList /></RequireAdmin>} />
            <Route path="/admin/tamu/baru" element={<RequireAdmin><VisitorForm /></RequireAdmin>} />
            <Route path="/admin/tamu/edit/:id" element={<RequireAdmin><VisitorForm /></RequireAdmin>} />
            <Route path="/admin/pengaturan" element={<RequireAdmin><SettingsPage /></RequireAdmin>} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/cetak/absensi/:id" element={<RequireAdmin><PrintAbsensi /></RequireAdmin>} />
          <Route path="/cetak/surat-pernyataan/:id" element={<RequireAdmin><PrintSuratPernyataan /></RequireAdmin>} />
          <Route path="/cetak/absensi-gabungan" element={<RequireAdmin><PrintBulkAbsensi /></RequireAdmin>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
